<template>
  <div class="bottomsheet">
    <div class="glass" :class="{ open: show }" @click="close"></div>
    <div class="bottomsheet-body" :class="{ open: show }">
      <div class="bottomsheet-header">
        <div class="bottomsheet-title">
          <slot name="title"></slot>
        </div>
        <span>
          <slot name="buttons"></slot>
          <button class="fab" @click="close">
            <material-icon name="close" :size="18"></material-icon>
          </button>
        </span>
      </div>
      <div class="bottomsheet-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom-sheet",
  props: ["show", "onClose"],
  methods: {
    close() {
      this.onClose();
    },
  },
  ready: function () {
    document.addEventListener("keydown", (e) => {
      if (this.show && e.keyCode === 27) {
        this.onClose();
      }
    });
  },
};
</script>
